<template>
    <div class="privacy-wrap">
        <div v-if="isAgreeShow" @click="onRadio" class="radioimg">
            <svg
                v-if="isAgree"
                width="100%"
                height="100%"
                viewBox="0 0 18 18"
                class="radio_selected"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8Z"
                    fill="#00BEBE"
                />
                <path
                    d="M11.9964 5.48304C12.5582 4.8741 13.5072 4.83573 14.1163 5.39733L8.45943 11.5299C8.09199 11.9282 7.47411 11.9614 7.06614 11.6046L3.5 8.48638C4.06484 7.8701 5.01693 7.81358 5.65071 8.35871L7.70951 10.1295L11.9964 5.48304Z"
                    fill="white"
                />
            </svg>
            <svg
                v-else
                width="100%"
                height="100%"
                viewBox="0 0 18 18"
                class="radio_unselected"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16ZM8.5 15C4.63401 15 1.5 11.866 1.5 8C1.5 4.13401 4.63401 1 8.5 1C12.366 1 15.5 4.13401 15.5 8C15.5 11.866 12.366 15 8.5 15Z"
                    fill="#040b29"
                />
            </svg>
        </div>

        <div class="privacy-ctx" v-if='!labelHtml'>
            <!-- target="_blank" href="https://www.nio.cn/privacy-policy" -->
            <template v-if="showMulti && linkConfig && linkConfig.length">
                <div class="privacy-ctx-a">
                    <span class="privacy-ctx-t">{{ linkLeftTxt }}</span
                    ><a
                        v-for="(item, index) in linkConfig"
                        :key="index"
                        @click="onShowMulti(item)"
                        >{{ item.text }}</a
                    >
                </div>
            </template>
            <template v-else>
                <div class="privacy-ctx-a">
                    <span class="privacy-ctx-t">{{ linkLeftTxt }}</span
                    ><a
                        :class="['privacy-ctx-a', linkTo ? 'a-link' : '']"
                        @click="onShow"
                        >{{ linkRightTxt }}</a
                    >
                </div>
            </template>
        </div>
        <template v-else>
            <div class='privacy-ctx' @click='handleClickLink'  data-test='1'>
                <div class="privacy-ctx-t" v-html='labelHtml' />
            </div>
            <privacy-content-actionsheet ref='privacyActionSheet' v-if='detail' v-bind='detail'></privacy-content-actionsheet>
        </template>

    </div>

</template>
<script>
  import PrivacyContentActionsheet from './privacy-content-actionsheet.vue';

  export default {
      components: { PrivacyContentActionsheet },
      props: {
          isAgreeShow: {
              type: Boolean,
              default: true
          },
          isAgree: {
              type: Boolean,
              default: false
          },
          labelHtml: {
              type: String,
              default: ''
          },
          detail:{
              type: Object,
              default() {return null}
          },
          linkLeftTxt: {
              type: String,
              default: '我已同意'
          },
          linkRightTxt: {
              type: String,
              default: '《蔚来汽车隐私条款》'
          },
          linkTo: {
              type: String,
              default: '/privacy'
          },
          // 是否展示多个隐私协议
          showMulti: {
              type: Boolean,
              default: false
          },
          linkConfig: {
              type: Array,
              default: () => [{ text: '《蔚来汽车隐私条款》', linkTo: '/privacy' }]
          }
      },
      data() {
          return {};
      },
      methods: {
          onRadio() {
              const agreed = !this.isAgree
              this.$emit('update:isAgree', agreed);
              this.$emit('change', agreed);
          },
          onShow() {
              if (!this.linkTo) {
                  return;
              }
              if (this.linkTo.startsWith('http')) {
                  window.location.href = this.linkTo;
              } else {
                  this.$router.push({ path: this.linkTo });
              }
          },
          handleClickLink(event) {
              debugger
              console.log('event', event)
              if (event.target && event.target.tagName === 'A') {
                  event.preventDefault();
                  event.stopPropagation();
                  const showDialog = event.target.dataset['showDialog'];
                  console.log('showDialog', showDialog)
                  if (showDialog === '1') {
                      this.$refs.privacyActionSheet.openDialog();
                      return;
                  }
                  const linkTo = event.target.getAttribute('href');
                  if (linkTo) {
                      if (this.linkTo.startsWith('http')) {
                          window.location.href = linkTo
                      } else {
                          this.$router.push({ path: linkTo });
                      }
                  }
              }
          },
          onShowMulti(item) {
              if (!item.linkTo) {
                  return;
              }
              if (item.linkTo.startsWith('http')) {
                  window.location.href = item.linkTo;
              } else {
                  this.$router.push({ path: item.linkTo });
              }
          }
      }
  };
</script>

<style lang="less">
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';
.privacy-wrap {
    font-size: 12 * @layout375;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20 * @layout375;
    .radioimg {
        width: 18 * @layout375;
        height: 18 * @layout375;
        // &.radio_dis {
        //     background-image: url(~src/assets/images/radio_dis.png);
        //     background-size: contain;
        //     background-repeat: no-repeat;
        //     background-position: center;
        // }
        // &.radio_select {
        //     background-image: url(~src/assets/images/radio_select.png);
        //     background-size: contain;
        //     background-repeat: no-repeat;
        //     background-position: center;
        // }
    }
    .privacy-ctx {
        margin-left: 10 * @layout375;
        .privacy-ctx-a {
            color: #00bebe;
        }
        .privacy-ctx-t {
            color: #040B29;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/testdrive_components/form/privacy/index.vue